import { render, staticRenderFns } from "./ConfirmDeleteModal.vue?vue&type=template&id=da51d836&scoped=true"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da51d836",
  null
  
)

export default component.exports